import { HttpClient, HttpEvent, HttpHeaders, HttpRequest} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { ServiceItem } from '../../../../services/framework/serviceitem'; 
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BaseWithHttpService {
  apiKey: string = '';
  constructor(protected http: HttpClient, @Inject(OKTA_AUTH) private auth: OktaAuth) {
    
  }

  protected getAny(url: string) {
    const token = this.getToken();
    if (token != undefined) {
      return this.http.get(url, this.getHttpOptions(token)).toPromise();
    }
    else {
      return Promise.reject('No token');
    }
  }

  protected postAny(content: any, url: string) {
    const token = this.getToken();
    if (token != undefined) {
      return this.http.post(url,content, this.getHttpOptions(token)).toPromise();
    }
    else {
      return Promise.reject('No token');
    }
  }

  protected deleteAny(url: string) {
    const token = this.getToken();
    if (token != undefined) {
      return this.http.delete(url, this.getHttpOptions(token)).toPromise();
    }
    else {
      return Promise.reject('No token');
    }
  }

  protected putAny(content: any, url: string) {
    const token = this.getToken();
    if (token != undefined) {
      return this.http.put(url, content, this.getHttpOptions(token)).toPromise();
    }
    else {
      return Promise.reject('No token');
    }
  }

  protected getItems<T extends ServiceItem>(url: string): Promise<T[]> {
    const token = this.getToken();
    if (token != undefined) {
      return this.http.get<T[]>(url, this.getHttpOptions(token)).toPromise();
    }
    else {
      return Promise.reject('No token');
    }
  }

  protected getItem<T extends ServiceItem>(url: string): Promise<T> {
    const token = this.getToken();
    if (token != undefined) {
      return this.http.get<T>(url, this.getHttpOptions(token)).toPromise();
    }
    else {
      return Promise.reject('No token');
    }
  }

  protected removeItem<T extends ServiceItem>(_item: T, url:string): Promise<boolean> {
    const token = this.getToken();
    
    if (token != undefined) {
      return this.http.delete<boolean>(url, this.getHttpOptions(token)).toPromise();
    }
    else {
      return Promise.reject('No token');
    }
  }

  protected saveItem<T extends ServiceItem>(item: T, isNew: boolean, url:string): Promise<boolean> {
    const token = this.getToken();
    
    if (token != undefined) {
      if (isNew) {
        return this.http.post<boolean>(url, item, this.getHttpOptions(token)).toPromise();
      }
      else {
        return this.http.put<boolean>(url, item, this.getHttpOptions(token)).toPromise();
      }
    }
    else {
      return Promise.reject('No token');
    }
  }

  protected  getToken(): string | undefined {
    return this.auth.getAccessToken();
  }
  
  protected  getHttpOptions(token: string): object {
    
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'Ocp-Apim-Subscription-Key': this.apiKey
      })
    };

  }
  protected postAnyFormData(content: any, url: string) {
    const token = this.getToken();
    if (token != undefined) {
      return this.http.post(url, content, this.getHttpOptionsFormData(token)).toPromise();
    }
    else {
      return Promise.reject('No token');
    }
  }
  /**
   * Posts form data and returns the raw response bytes rather than parsed JSON.
   * Used for downloads the API streams, where the payload is the file itself.
   */
  protected postAnyFormDataBlob(content: any, url: string): Promise<Blob> {
    const token = this.getToken();
    if (token != undefined) {
      // Headers are pulled out rather than spread so the compiler can resolve the
      // blob-returning overload of post() unambiguously.
      const { headers } = this.getHttpOptionsFormData(token) as { headers: HttpHeaders };
      return this.http.post(url, content, { headers, responseType: 'blob' }).toPromise() as Promise<Blob>;
    }
    else {
      return Promise.reject('No token');
    }
  }

  protected getHttpOptionsFormData(token: string): object {

    return {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + token,
        'Accept': '*/*',
        'Access-Control-Allow-Headers': 'origin,X-Requested-With,content-type,accept',
        'Ocp-Apim-Subscription-Key': this.apiKey
      })
    };

  }

  protected getHttpOptionsFileTypeParams(token: string, url: string): Observable<HttpEvent<Blob>> {

    const options = {
      headers: new HttpHeaders({
        'Accept': 'application/zip',
        'Authorization': 'Bearer ' + token,
        'Access-Control-Allow-Headers': 'origin,X-Requested-With,content-type,accept'
      }),
      responseType: 'blob' as 'json',
      reportProgress: true
    };

    const req = new HttpRequest('GET', url, null, options);
    return this.http.request(req);
  }

  public getHttpOptionsObjectTypeParams(token: string, url: string): Observable<any> {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    };

    const req = new HttpRequest('GET', url, null, options);
    return this.http.request(req);
  }
}
